import React from "react"
import Partner1 from "../../images/partner-img-1.png"
import Partner2 from "../../images/partner-img-2.png"
import Arrow from "../../images/long-arrow-right.svg"
import { useMediaQuery } from "react-responsive"

const PartnerOrg = () => {
  let isMobile = useMediaQuery({ query: "(max-device-width: 576px)" })
  return (
    <section id="partner-org">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="title-txt">Key Strategy</div>
            <h1>Partner Organizations</h1>
            {isMobile ? (
              <></>
            ) : (
              <button className="find-help-btn btn">
                Learn more
                <span className="pl-2">
                  <img src={Arrow} alt="" style={{ margin: "0" }} />
                </span>
              </button>
            )}
          </div>
          <div class="col-md-6 mt-5">
            <p>
              Professional treatment and interventions often play a crucial role
              in helping people to win over addictions.
            </p>
          </div>
        </div>
        {isMobile ? (
          <button className="find-help-btn btn">
            Learn more
            <span className="pl-2">
              <img src={Arrow} alt="" style={{ margin: "0" }} />
            </span>
          </button>
        ) : (
          <></>
        )}
        <div class="row resourse-desc-wrapper">
          <div class="col-md-6 img-wrapper-xs">
            <img src={Partner2} alt="" class="img-one img-fluid" />
            <img src={Partner1} alt="" class="img-two img-fluid" />
          </div>
          <div class="col-md-6 mt-auto text-wrapper">
            <p>
              Consulting a treatment facility or a specialist is a pivotal point
              in achieving a sober life. That is why Rehab Find is in
              partnership with the best specialist and addiction treatment
              centers around Canada. With these, people can find the perfect fit
              for rehabilitation treatments that accommodates an individual’s
              unique needs.Rehab Find is a unique online rehab facility finder
              that can connect a recovering addict with a specialist or a clinic
              at a moment’s notice. Are you looking for in-person care from a
              specialist? Do you want to be an in-patient at the best rehab
              centre for you? Use our most comprehensive database of rehab
              centers online. Let us help you quickly find the perfect
              specialist or center to help your rehabilitation today!
            </p>
          </div>
          <div class="col-md-6 img-wrapper text-center">
            <img src={Partner2} alt="" class="img-one img-fluid" />
            <img src={Partner1} alt="" class="img-two img-fluid" />
          </div>
        </div>
      </div>
      <hr />
    </section>
  )
}

export default PartnerOrg
